import { areCookiesAuthorized, combine, createEventRateLimiter, Observable, trackRuntimeError, trackConsoleError, canUseEventBridge, getEventBridge, getRelativeTime, startInternalMonitoring } from '@datadog/browser-core';
import { trackNetworkError } from '../domain/trackNetworkError';
import { StatusType } from '../domain/logger';
import { startLogsSessionManager, startLogsSessionManagerStub } from '../domain/logsSessionManager';
import { startLoggerBatch } from '../transport/startLoggerBatch';
export function startLogs(configuration, errorLogger) {
  var internalMonitoring = startInternalMonitoring(configuration);
  var errorObservable = new Observable();
  if (configuration.forwardErrorsToLogs) {
    trackConsoleError(errorObservable);
    trackRuntimeError(errorObservable);
    trackNetworkError(configuration, errorObservable);
  }
  var session = areCookiesAuthorized(configuration.cookieOptions) && !canUseEventBridge() ? startLogsSessionManager(configuration) : startLogsSessionManagerStub(configuration);
  return doStartLogs(configuration, errorObservable, internalMonitoring, session, errorLogger);
}
export function doStartLogs(configuration, errorObservable, internalMonitoring, sessionManager, errorLogger) {
  internalMonitoring.setExternalContextProvider(function () {
    var _a;
    return combine({
      session_id: (_a = sessionManager.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
    }, getRUMInternalContext(), {
      view: {
        name: null,
        url: null,
        referrer: null
      }
    });
  });
  var assemble = buildAssemble(sessionManager, configuration, reportError);
  var onLogEventCollected;
  if (canUseEventBridge()) {
    var bridge_1 = getEventBridge();
    onLogEventCollected = function onLogEventCollected(message) {
      return bridge_1.send('log', message);
    };
  } else {
    var batch_1 = startLoggerBatch(configuration);
    onLogEventCollected = function onLogEventCollected(message) {
      return batch_1.add(message);
    };
  }
  function reportError(error) {
    errorLogger.error(error.message, combine({
      date: error.startClocks.timeStamp,
      error: {
        kind: error.type,
        origin: error.source,
        stack: error.stack
      }
    }, error.resource ? {
      http: {
        method: error.resource.method,
        status_code: error.resource.statusCode,
        url: error.resource.url
      }
    } : undefined));
  }
  errorObservable.subscribe(reportError);
  return function (message, currentContext) {
    var contextualizedMessage = assemble(message, currentContext);
    if (contextualizedMessage) {
      onLogEventCollected(contextualizedMessage);
    }
  };
}
export function buildAssemble(sessionManager, configuration, reportError) {
  var errorRateLimiter = createEventRateLimiter(StatusType.error, configuration.maxErrorsPerMinute, reportError);
  return function (message, currentContext) {
    var startTime = message.date ? getRelativeTime(message.date) : undefined;
    var session = sessionManager.findTrackedSession(startTime);
    if (!session) {
      return undefined;
    }
    var contextualizedMessage = combine({
      service: configuration.service,
      session_id: session.id
    }, currentContext, getRUMInternalContext(startTime), message);
    if (configuration.beforeSend && configuration.beforeSend(contextualizedMessage) === false) {
      return undefined;
    }
    if (contextualizedMessage.status === StatusType.error && errorRateLimiter.isLimitReached()) {
      return undefined;
    }
    return contextualizedMessage;
  };
}
function getRUMInternalContext(startTime) {
  var rum = window.DD_RUM;
  return rum && rum.getInternalContext ? rum.getInternalContext(startTime) : undefined;
}